import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Telescope } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/_panel/_performance")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("performance", context.tenant.modules);

    return {
      title: () => context.t("Performance Mgmt", { ns: "performance.shared" }),
      crumb: [
        {
          Icon: Telescope,
        },
        {
          label: context.t("Performance Mgmt", {
            ns: "performance.shared",
          }),
          link: {
            to: "/performance/objectives",
          },
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
